import { InjectionToken } from '@angular/core';
import { TrackingConfig } from './tracking.interface';

export const TRACKING_CONFIG = new InjectionToken<TrackingConfig>(
  'TrackingConfig',
);



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/@shared/tracking/tracking.config.ts